var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFraudulentActivity = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "M23.35 7.698v2.49h-.338a7.3 7.3 0 0 0-3.991-1.179c-1.47 0-2.84.434-3.991 1.179H3.756v-2.49c0-.653.53-1.185 1.183-1.185h17.227c.653 0 1.184.532 1.184 1.185M12.356 19.493H4.938a1.186 1.186 0 0 1-1.183-1.185v-5h8.573a7.3 7.3 0 0 0-.67 3.064c0 1.093.25 2.172.696 3.12M19.021 10.57a5.81 5.81 0 0 0-5.802 5.802c0 3.2 2.603 5.801 5.802 5.801a5.81 5.81 0 0 0 5.802-5.801 5.81 5.81 0 0 0-5.802-5.803m3.317 9.144c0 .086-.07.156-.156.156h-2.455c-.263 0-.417-.573-.796-.636-.38.063-.534.636-.797.636H15.68a.156.156 0 0 1-.156-.156v-2.018c0-.087.07-.156.156-.156h6.502c.085 0 .156.07.156.156zm.562-3.273h-7.758a.35.35 0 0 1 0-.701h.873c.156-2.897.657-2.868 1.22-2.868.565 0 .839.437 1.762.437h.007c.923 0 1.184-.437 1.76-.437s1.065-.03 1.222 2.868h.914a.35.35 0 0 1 0 .701"
  })));
};
export default SvgFraudulentActivity;